module.exports = __webpack_public_path__ + "img/lyylm2.81e0319c.jpg";